import React from "react";
import Navbar from "./components/Navbar";
import Home from "./page/Home";

const App = () => {
  return (
    <main>
      <Navbar />
      <Home />
    </main>
  );
};

export default App;
